import React from 'react';
import { IIcon } from '../../@types/icons';

export function NotificationBell ({size = 24}: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.167 20.938a1.913 1.913 0 003.671 0M12 3.75V1.687M12 3.75v0a6.875 6.875 0 016.875 6.875c0 6.459 1.375 7.563 1.375 7.563H3.75s1.375-1.757 1.375-7.563v0A6.875 6.875 0 0112 3.75v0z"
      />
    </svg>
  );
}
